export const colors = {
    baseColor: "#F5F5F5"
}

export const appVersion = "v2.0+1"